export default {
  audienceNotice: 'AudienceNotice',
  dataSourcesNotice: 'DataSourcesNotice',
  surveyNotice: 'SurveyNotice',
  verificationBanner: 'VerificationBanner'
}
